<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild
            :use-background-mobile="true"
            :settings="fields.settings"
            :container-page="fields.containerPage"
          />
        </div>

        <div class="mb-4">
          <div class="d-flex align-center mb-2" style="gap: 10px">
            <label class="label-input mb-0">Card Title</label>
            <input type="checkbox" v-model="fields.cardTitle.show" />
          </div>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields.cardTitle.content" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Content Card</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="fields.contentCard.width"
                  type="number"
                  label="Width"
                  min="0"
                  suffix="px"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select v-model="fields.contentCard.align" :items="alignOptions" label="Align" hide-details />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center">
            <label class="label-input mb-0">Slides</label>
            <v-btn small text color="primary" @click="handleAddSlide">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Slide</span>
            </v-btn>
          </div>
          <div class="group-item">
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, index) in fields.slides" :key="`rivoneed-slide-${index}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Slide {{ index + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveSlide(index)">
                      <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mb-3">
                    <UploadImage
                      @callback="obj => handleUploadSlideImage(obj, index)"
                      :image="{ imageSrc: item.image || '' }"
                      :height="`160`"
                      :typeUpload="'image'"
                      @callbackDelete="() => handleRemoveSlideImage(index)"
                    />
                  </div>
                  <div>
                    <v-text-field
                      v-model.number="item.overlayOpacity"
                      type="number"
                      label="Overlay Opacity (0-1)"
                      min="0"
                      max="1"
                      step="0.1"
                      hide-details
                    />
                  </div>
                  <v-text-field v-model="item.alt" class="mt-3" label="Image alt" hide-details />
                  <div class="mt-4">
                    <label class="mb-2 d-block">Title</label>
                    <ckeditor :editor="editor" v-model="item.title" :config="editorConfig" />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center">
            <label class="label-input mb-0">Benefits</label>
            <v-btn small text color="primary" @click="handleAddBenefit">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Benefit</span>
            </v-btn>
          </div>
          <div class="group-item">
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, index) in fields.benefits" :key="`rivoneed-benefit-${index}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Benefit {{ index + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveBenefit(index)">
                      <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <UploadImage
                    @callback="obj => handleUploadBenefitIcon(obj, index)"
                    :image="{ imageSrc: item.icon || '' }"
                    :height="`100`"
                    :typeUpload="'image'"
                    @callbackDelete="() => handleRemoveBenefitIcon(index)"
                  />
                  <v-text-field v-model="item.alt" class="mt-3" label="Icon alt" hide-details />
                  <div class="mt-4">
                    <label class="mb-2 d-block">Text</label>
                    <ckeditor :editor="editor" v-model="item.content" :config="editorConfig" />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

const defaultSlideImage = '';
const defaultBenefitIcon = 'https://cdn.skyfastimg.com/images/2026/06/12/image-6a2bcf24d2e624d0a3851246.png';

export default {
  name: 'card-with-slider-rivoneed-section-editor',
  components: {
    UploadImage,
    SectionSettingsContainerFuild,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      alignOptions: ['left', 'center', 'right'],
      fields: {
        title: 'Card With Slider Rivoneed Section',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        cardTitle: {
          show: true,
          content:
            '<h2>Multiple Modes. Adapt To Any Task.</h2><p>See every detail clearly and finish repairs faster with less effort.</p>',
        },
        contentCard: {
          width: 549,
          align: 'left',
        },
        slides: [],
        benefits: [],
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        cardTitle: { ...this.fields.cardTitle, ...(extract.cardTitle || {}) },
        contentCard: { ...this.fields.contentCard, ...(extract.contentCard || {}) },
        slides: Array.isArray(extract.slides) ? extract.slides : this.fields.slides,
        benefits: Array.isArray(extract.benefits) ? extract.benefits : this.fields.benefits,
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardWithSliderRivoneed(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddSlide() {
      this.fields.slides.push({
        image: defaultSlideImage,
        alt: '',
        title: '<h3>4 Level Brightness</h3>',
      });
    },
    handleRemoveSlide(index) {
      this.fields.slides.splice(index, 1);
    },
    handleUploadSlideImage(obj, index) {
      if (!this.fields.slides[index]) return;
      this.$set(this.fields.slides[index], 'image', obj.imageSrc || '');
    },
    handleRemoveSlideImage(index) {
      if (!this.fields.slides[index]) return;
      this.$set(this.fields.slides[index], 'image', '');
    },
    handleAddBenefit() {
      this.fields.benefits.push({
        icon: defaultBenefitIcon,
        alt: '',
        content: '<p>Choose the ideal light color for work, repairs, or outdoor use.</p>',
      });
    },
    handleRemoveBenefit(index) {
      this.fields.benefits.splice(index, 1);
    },
    handleUploadBenefitIcon(obj, index) {
      if (!this.fields.benefits[index]) return;
      this.$set(this.fields.benefits[index], 'icon', obj.imageSrc || '');
    },
    handleRemoveBenefitIcon(index) {
      if (!this.fields.benefits[index]) return;
      this.$set(this.fields.benefits[index], 'icon', '');
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
